import { Dialog, DialogTitle, DialogContent, DialogActions, Button, FormGroup, FormControlLabel, Checkbox, Typography } from "@mui/material";
import { useState, useEffect } from "react";
import { useSnackbar } from 'notistack';

export default function ExportDialog(props: any) {
    const { open, setOpen, setLoading, exportFields, onExport } = props;
    const [selectedFields, setSelectedFields] = useState<string[]>([]);
    const { enqueueSnackbar } = useSnackbar();
    
    
    const formatFieldLabel = (field: string) => {
        return field
            .replace(/_/g, ' ') 
            .replace(/\b\w/g, (char) => char.toUpperCase());
    };

    useEffect(() => {
        if (open) {
            setSelectedFields([]);
        }
    }, [open]);

    const handleFieldChange = (field: string, checked: boolean) => {
        if (checked) {
            setSelectedFields(prev => [...prev, field]);
        } else {
            setSelectedFields(prev => prev.filter(f => f !== field));
        }
    };

    const handleSelectAll = () => {
        if (selectedFields.length === exportFields.length) {
            setSelectedFields([]);
        } else {
            setSelectedFields([...exportFields]);
        }
    };

    const handleExport = () => {
        console.log('Exporting fields:', selectedFields);
        if (selectedFields.length === 0) {
            enqueueSnackbar('You must select at least one field to export.', {variant: 'error'});
            return;
        }

        onExport(selectedFields);
        setOpen(false);
    };

    const handleCancel = () => {
        setSelectedFields([]);
        setOpen(false);
    };

    return (
        <Dialog open={open} onClose={handleCancel} maxWidth="sm" fullWidth>

            <div className="DialogContainer">
                <div className="ModuleWrapper">
                    <div className="boxContainerHeader">
                        <div className="dialog_container_title">
                            <h2 className="dialog_title">Export Orders</h2>
                            <span className="dialog_subtitle">Select the fields you want to include in the CSV export</span>
                        </div>
                    </div>
                
                    <div className="dialogFormContainer">
                        <FormGroup>
                            {exportFields.map((field: string) => (
                                <FormControlLabel
                                    key={field}
                                    control={
                                        <Checkbox
                                            checked={selectedFields.includes(field)}
                                            onChange={(e) => handleFieldChange(field, e.target.checked)}
                                        />
                                    }
                                    label={formatFieldLabel(field)}
                                />
                            ))}
                        </FormGroup>

                        <a onClick={handleSelectAll} className="addProductButton">
                            {selectedFields.length === exportFields.length ? 'Deselect All' : 'Select All'}
                        </a>

                    </div>
                </div>
            </div>

            
            <DialogActions style={{ padding: '16px 24px' }}>
                <Button onClick={handleCancel} color="inherit">
                    Cancel
                </Button>
                <Button 
                    onClick={handleExport} 
                    variant="contained" 
                    color="primary"
                >
                    Export CSV
                </Button>
            </DialogActions>
        </Dialog>
    )
}